import { render, staticRenderFns } from "./Leetcode1512.vue?vue&type=template&id=7c352ff4&"
import script from "./Leetcode1512.vue?vue&type=script&lang=js&"
export * from "./Leetcode1512.vue?vue&type=script&lang=js&"
import style0 from "./Leetcode1512.vue?vue&type=style&index=0&id=7c352ff4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports